import * as utils from '@/utils/util'

export const getSession = () => {
  const type = utils.getEnv()
  if (type === 'test') {
    return utils.cookie.get('ds_auth_test')
  } else if (type === 'pre') {
    return utils.cookie.get('ds_auth')
  } else {
    return utils.cookie.get('ds_auth')
  }
}

export const clearSession = () => {
  const mainHost = utils.mainHost()
  const type = utils.getEnv()
  if (type === 'test') {
    utils.cookie.set('ds_auth_test', null, { domain: mainHost, path: '/' })
  } else if (type === 'pre') {
    utils.cookie.set('ds_auth', null, { domain: mainHost, path: '/' })
  } else {
    utils.cookie.set('ds_auth', null, { domain: mainHost, path: '/' })
  }
}

export const getUserInfo = () => {
  const type = utils.getEnv()
  try{
    if (type === 'test') {
      return JSON.parse(localStorage.getItem('dev_admin_info'));
    } else if (type === 'pre') {
      return JSON.parse(localStorage.getItem('pre_admin_info'));
    } else {
      return JSON.parse(localStorage.getItem('admin_info'));
    }
  } catch(e) {
    return '';
  }
}

export const setUserInfo = (data) => {
  const type = utils.getEnv()
  const mainHost = utils.mainHost()
  if (type === 'test') {
    localStorage.setItem('dev_admin_info', JSON.stringify(data));
    utils.cookie.set('dev_admin_info', data, { domain: mainHost, path: '/' })
  } else if (type === 'pre') {
    localStorage.setItem('pre_admin_info', JSON.stringify(data));
    utils.cookie.set('pre_admin_info', data, { domain: mainHost, path: '/' })
  } else {
    localStorage.setItem('admin_info', JSON.stringify(data));
    utils.cookie.set('admin_info', data, { domain: mainHost, path: '/' })
  }
}

export const clearUserInfo = () => {
  const type = utils.getEnv()
  const mainHost = utils.mainHost()
  if (type === 'test') {
    localStorage.setItem('dev_admin_info', '');
    utils.cookie.set('dev_admin_info', null, { domain: mainHost, path: '/' })
  } else if (type === 'pre') {
    localStorage.setItem('pre_admin_info', '');
    utils.cookie.set('pre_admin_info', null, { domain: mainHost, path: '/' })
  } else {
    localStorage.setItem('admin_info', '');
    utils.cookie.set('admin_info', null, { domain: mainHost, path: '/' })
  }
}

export const logout = () => {
  clearSession();
  clearUserInfo();
}



// WEBPACK FOOTER //
// ./src/utils/login.js